import api from "api";
import { supportApiBase } from "api/constants";
import { useQuery } from "react-query";
import { queryKeys } from "utils/misc";
import { LessonListResponseDto } from "./lessonDtos";
import { rolloutRefetchInterval } from "./catalogueDeployments";
import { CatalogueQuery, catalogueSearchParams } from "../components/CatalogueList";

type ListLessonsParams = CatalogueQuery & { joints: string[] };

const buildQuery = (params: ListLessonsParams): string => {
  const qs = catalogueSearchParams(params);
  params.joints.forEach(j => qs.append("joint", j));
  return qs.toString();
};

export const useListLessons = (params: ListLessonsParams) =>
  useQuery<LessonListResponseDto>(
    queryKeys.lessonsList(params),
    () =>
      // @ts-ignore — v2 endpoint, not in OpenAPI types
      api.parse(`GET /lessons?${buildQuery(params)}`, { root: supportApiBase }),
    { keepPreviousData: true, refetchInterval: data => rolloutRefetchInterval(data?.items) }
  );
